import { DesktopIcon, MoonIcon, SunIcon } from "@phosphor-icons/react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useTheme, type Theme } from "@/lib/hooks/useTheme";
import { cn } from "@/lib/utils";

interface ThemeSegmentedProps {
  className?: string;
}

/**
 * 3-állású témaválasztó (Világos / Sötét / Rendszer) ToggleGroup-pal.
 *
 * Ez az EGYETLEN témaválasztó: a `NavMenu`-ben (ami a mobil fejléc-panelben ÉS az asztali
 * `UserMenu` dialógusában is ugyanez a komponens) és a profil `AppearanceCard`-jában.
 * Egy kattintással váltó ikon-gomb szándékosan nincs a fejlécben: a „Rendszer" beállítás
 * abból nem érhető el, és a fejlécnek két állapota (világos/sötét) mást mutatna, mint a
 * menüben látható három.
 */
export function ThemeSegmented({ className }: ThemeSegmentedProps) {
  const { theme, setTheme } = useTheme();

  return (
    <ToggleGroup
      variant="outline"
      aria-label="Téma kiválasztása"
      className={cn("grid w-full grid-cols-3", className)}
      value={[theme]}
      onValueChange={([val]) => {
        if (val) setTheme(val as Theme);
      }}
    >
      <ToggleGroupItem value="light" className="gap-1.5 py-2 text-xs">
        <SunIcon className="size-4 shrink-0" aria-hidden="true" />
        <span>Világos</span>
      </ToggleGroupItem>
      <ToggleGroupItem value="dark" className="gap-1.5 py-2 text-xs">
        <MoonIcon className="size-4 shrink-0" aria-hidden="true" />
        <span>Sötét</span>
      </ToggleGroupItem>
      <ToggleGroupItem value="system" className="gap-1.5 py-2 text-xs">
        <DesktopIcon className="size-4 shrink-0" aria-hidden="true" />
        <span>Rendszer</span>
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
